const checkPermission = (permission: string | string[]): boolean => {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return false;
    const user = JSON.parse(raw);
    const permissions: unknown = user?.permissions;
    if (Array.isArray(permissions)) {
      if (Array.isArray(permission)) {
        return permission.some((item) => permissions.includes(item));
      }
      return permissions.includes(permission);
    }
    return false;
  } catch {
    return false;
  }
};

export const checkSuperAdmin = (): boolean => {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return false;
    const user = JSON.parse(raw);
    return Boolean(user?.isSuperAdmin);
  } catch {
    return false;
  }
};

export default checkPermission;
